export default __webpack_public_path__ + "static/media/circled-warning-red.bfd23fac.svg";